import {RowEngagementPanelType, RowEngagementType} from "~/components/ottopilotDataViewer/rowEngagementPanel";
import type {OttopilotDataViewerController} from "~/components/ottopilotDataViewer/ottopilotDataViewerController";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export function dismissDataViewerRowEngagementPanel<T extends {id: Uuid}>(
    controllerRef: {current: OttopilotDataViewerController<T> | null} | undefined,
): void {
    const controller = controllerRef?.current;
    if (controller === null || controller === undefined) {
        return;
    }
    controller.setCurrentlyOpenRowEngagementPanel({
        rowEngagementType: RowEngagementType.none,
        rowEngagementPanelType: RowEngagementPanelType.none,
        rowEngagementData: null,
    });
}
